<div class="footer-lgpd">
  <div class="container">
    <p class="blue-title">Não encontrou o que procurava?</p>
    <div class="boxes-area">
      <div class="box-1">
        <p class="gray-title">Dúvidas Frequentes</p>
        <a class="link-text" href="#">Tire suas dúvidas sobre a Lei Geral de<br>Proteção de Dados Pessoais</a>
      </div>
      <div class="box-2">
        <p class="gray-title">Central de Atendimento</p>
        <p>Ligue para <strong>3003-6300</strong></p>
      </div>
    </div>
    <div class="help-area">
      <p>Não encontrou sua resposta? Deixa que a gente ajuda</p>
      <a href="https://ajuda.serasa.com.br/hc/pt-br/sections/360000259691-D%C3%BAvidas-sobre-outros-servi%C3%A7os">
        <button>Central de Ajuda</button>
      </a>

    <div class="modal-footer" style="font-size: 14; display: flex; flex-direction: column;">
      <strong>Contate o Encarregado de<br> Proteção de Dados:</strong>
      <p class="dados">Emiliano Tozetto<br>
        <u>dpo&#64;br.experian.com</u></p>
    </div>

    </div>
    <p class="note">Caso você não concorde com os Termos de Uso e Política de Privacidade da Serasa e queira acessar
      exclusivamente os seus dados pessoais e mais serviços de Proteção de Dados Pessoais, <a
        (click)="showModal()" >clique aqui</a>.</p>
  </div>
</div>
